import React from "react";
import { connect, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../shared/Button/Button";
import InputController from "../../shared/Input/InputField/InputController";
import password_lock from "../../../assets/svgs/password_lock.svg";
import { changePassword } from "../../../redux/slices/updateUserSlice";
import { changePasswordStyle as styles } from "../myContact.tailwind";
import { updatePasswordValidationSchema, setPasswordValidationSchema } from "../updateValidationSchema";

const ChangePassword = ({ setPassword, resetTab }) => {
  const { user } = useSelector((state) => state.user);
  const { changingPassword } = useSelector((state) => state.updateUser);
  const {passwordPolicy} = useSelector((state) => state.passwordPolicy);
  const profileData = user?.userDetails;

  const validationSchema = profileData?.hasPassword
    ? updatePasswordValidationSchema(passwordPolicy)
    : setPasswordValidationSchema(passwordPolicy);
  const { control, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(validationSchema), });


  const updateNewPassword = async (formData) => {
    const data = {
      userPassword: formData.password,
      userConfirmPassword: formData.confirmPassword,
    };

    // Include the old password only if it's visible
    if (profileData?.hasPassword) {
      data.oldPassword = formData.currentPassword;  // Add currentPassword to the data if the field is shown
    }
    // Dispatch to update the password
    const response = await setPassword(data);
    if (changePassword.fulfilled.match(response)) {
      reset(); // Reset the form after successful password change
      resetTab();
    }
  };

  return (
    <div className={styles.outerContainer}>
      <div className={styles.headerContainer}>
        <figure className={styles.figure}>
          <img src={password_lock} alt="Lock Image" className={styles.image} style={{ filter: "invert(1)" }} />
        </figure>
        <div className={styles.headingContainer}>
          <span className={styles.heading}>{profileData?.hasPassword ? "Change Password" : "Set Password"}</span>
          <p className={styles.paragraph}>
            To {profileData?.hasPassword ? "change" : "set"} your password, please fill the below fields
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit(updateNewPassword)} className={styles.formContainer}>

        {/* Input Fields */}
        <div className={styles.inputContainer}>

          {/* Current Password this field is only rendered if the user has set has password */}
          {profileData?.hasPassword && (
            <InputController
              showLabel={true}
              autoFocus={true}
              label="Current Password"
              type="password"
              name="currentPassword"
              control={control}
              error={!!errors.currentPassword}
              helperText={errors.currentPassword?.message}
            />
          )}

          {/* New Password */}
          <InputController
            showLabel={true}
            label="New Password"
            type="password"
            name="password"
            control={control}
            error={!!errors.password}
            helperText={errors.password?.message}
          />

          {/* Confirm Password */}
          <InputController
            showLabel={true}
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            control={control}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
          />
        </div>

        {/* ChangePassword Button */}
        <div className={styles.buttonContainer}>
          <Button variant="primary" type="submit" disabled={changingPassword} className={styles.button}>
            {profileData?.hasPassword
              ? (changingPassword ? "Updating..." : "Change Password")
              : (changingPassword ? "Saving..." : "Set Password")
            }
          </Button>
        </div>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setPassword: (data) => dispatch(changePassword(data)),
});

export default connect(null, mapDispatchToProps)(ChangePassword);